

































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AbstractItemModel } from '../models/items/abstract-item-model';
import { GenericItem } from '../models/items/generic-item-model';

import { ListModel, ListItemEntry } from '@/models/list-model';
import AddItemModal from '@/modals/AddItemModal.vue';

@Component({
  components: { AddItemModal }
})
export default class ListDetailFooter extends Vue {
  @Prop(ListModel) list: ListModel;
  @Prop(Array) items: AbstractItemModel[];

  showAddModal() {
    this.$modal.show(
      AddItemModal,
      { list: this.list },
      { classes: 'null-modal-class' }
    );
  }
}
